export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    tag: '3',
    tagVariant: 'light-warning',

    children: [
      {
        title: 'Statistics',
        route: 'dashboard-statistics',
        action: ['read', 'update'],
        resource: 'dashboard',
      },
      {
        title: 'Huay',
        route: 'huay-dashboard',
        action: ['read', 'update'],
        resource: 'dashboard',
      },
      {
        title: 'Result Dashboard',
        route: 'dashboard-result',
        action: ['read', 'update'],
        resource: 'dashboard',
      },
    ],
  },
]
